import { render, staticRenderFns } from "./HrQuickLinks.vue?vue&type=template&id=3e6ce2e0"
import script from "./HrQuickLinks.vue?vue&type=script&lang=js"
export * from "./HrQuickLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports